import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import {GruppeId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Temporal} from "temporal-polyfill";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {MatButton} from "@angular/material/button";
import {VisSpinnerDirektiv} from "web-ng2/delt/direktiver/button--visSpinner/button--visSpinner";
import {lagrerSignal} from "felles-ng2/tjenester/LagrerIndikator";
import {zonedDateTimeStartPåDagenFraPlainDate} from "felles-ng2/støttefunksjoner/temporal";
import {GjeldendeTidssone} from "felles-ng2/tjenester/i18n/GjeldendeTidssone";
import {lyttTilEsc} from "felles-ng2/støttefunksjoner/tastaturhendelser";
import {StandardValideringsfeilPipe} from "felles-ng2/pipes/StandardValideringsfeilPipe";
import {MatDatoformatKomponent} from "web-ng2/delt/komponenter/mat-datoformat/mat-datoformat";
import {åpneINyttvindu} from "felles-ng2/støttefunksjoner/nettleser";
import {RessursAdresser} from "felles-ng2/tjenester/ressurser/RessursAdresser";
import PlainDate = Temporal.PlainDate;

const debug = initDebugger('GruppeMøtedeltakelseeksportDialogKomponent');

export type GruppeMøtedeltakelseeksportDialogRespons = boolean;

/**
 * Modal dialog for eksport av møtedeltakelse til Excel-fil.
 */
@Component({
    selector: 'gruppe-moetedeltakelseeksport-dialog',
    templateUrl: 'gruppe-moetedeltakelseeksport-dialog.html',
    styleUrl: 'gruppe-moetedeltakelseeksport-dialog.scss',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatButton,
        MatDialogModule,
        TranslateModule,
        StandardValideringsfeilPipe,
        VisSpinnerDirektiv,
        MatDatoformatKomponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GruppeMøtedeltakelseeksportDialogKomponent {

    static vis(dialog: MatDialog, gruppeId: GruppeId): MatDialogRef<GruppeMøtedeltakelseeksportDialogKomponent, GruppeMøtedeltakelseeksportDialogRespons> {
        return dialog.open(GruppeMøtedeltakelseeksportDialogKomponent, {data: {gruppeId} as DialogParametre, disableClose: true, ariaLabelledBy: 'gruppe-møtedeltakelse-eksport-dialog-tittel', maxWidth: '600px'});
    }

    private gruppeId!: GruppeId;

    readonly skjema = new FormGroup({
        fraOgMed: new FormControl<PlainDate | null>(null, {validators: Validators.required}),
        tilOgMed: new FormControl<PlainDate | null>(null, {validators: Validators.required})
    });
    readonly genererer = lagrerSignal();

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                private gjeldendeTidssone: GjeldendeTidssone,
                private ressursAdresser: RessursAdresser,
                private dialogRef: MatDialogRef<GruppeMøtedeltakelseeksportDialogKomponent, GruppeMøtedeltakelseeksportDialogRespons>) {
        this.gruppeId = parametre.gruppeId;
        //dialog er konf med disableClose:true for å unngå at klikk utenfor dialog lukker denne, ønsker fortsatt at esc skal lukke
        lyttTilEsc(() => this.avbryt());
    }

    async lastNed() {
        åpneINyttvindu(this.eksporterMøteDeltakelseUrl());
        this.dialogRef.close(true);
    }

    avbryt() {
        this.dialogRef.close(false);
    }

    //private hjelpemetoder

    private eksporterMøteDeltakelseUrl() {
        const tidssone = this.gjeldendeTidssone.brukersTidssone();
        return this.ressursAdresser.eksporterMøteDeltakelseUrl(
          this.gruppeId,
          zonedDateTimeStartPåDagenFraPlainDate(this.skjema.value.fraOgMed!, tidssone),
          zonedDateTimeStartPåDagenFraPlainDate(this.skjema.value.tilOgMed!, tidssone));
    }
}

export interface DialogParametre {
    gruppeId: GruppeId;
}
